export default __webpack_public_path__ + "images/1bb3db45513909604e53605c2bcde4ce-box.svg";